import { atom, useAtom, useSetAtom } from "jotai";
import { PaymentLedger } from "../utils/interfaces";

export const ledgerAtom = atom(null as PaymentLedger | null);

const useLedger = () => {
  const atom = useAtom(ledgerAtom);
  return atom;
};
export const useSetLedger = () => useSetAtom(ledgerAtom);
export default useLedger;
